import { formatLlmModelDisplay } from '@/utils/llmModelDisplay'
import { cn } from '@/lib/utils'

interface LlmModelBadgeProps {
  llmModelName?: string | null
  llmProvider?: string | null
  legacyProvider?: string | null
  className?: string
}

const LlmModelBadge: React.FC<LlmModelBadgeProps> = ({
  llmModelName,
  llmProvider,
  legacyProvider,
  className,
}) => {
  const label = formatLlmModelDisplay(llmModelName, llmProvider, legacyProvider)
  if (!label) {
    return null
  }

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-full',
        className
      )}
    >
      {label}
    </span>
  )
}

export default LlmModelBadge
